import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './AvatarGroup.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "avatar-group" },
    [
      _c(
        "transition-group",
        {
          staticClass: "avatar-group-inner",
          attrs: {
            name: "participant",
            tag: "div",
            "over-limit": _vm.isOverLimit
          },
          on: { "before-leave": _vm.beforeLeave }
        },
        [
          _vm.$slots.before
            ? _c(
                "div",
                {
                  key: "slot-before",
                  staticClass: "avatar-wrapper",
                  style: { zIndex: _vm.count + 1 }
                },
                [_vm._t("before")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.visible, function(user, i) {
            return _c(
              "div",
              {
                key: user.key,
                staticClass: "avatar-wrapper",
                style: { zIndex: _vm.count - i },
                attrs: { "data-index": i, last: i === _vm.count - 1 }
              },
              [
                _c(
                  "Tooltip",
                  {
                    key: user.key,
                    staticClass: "tooltip",
                    attrs: { "append-to-body": true, label: user.displayName }
                  },
                  [
                    _c("Avatar", {
                      key: user.key,
                      staticClass: "avatar",
                      attrs: {
                        tag: user.link ? "a" : "span",
                        size: _vm.size,
                        link: user.link,
                        status: user.status,
                        outline: _vm.borderColor,
                        avatar: user.avatar,
                        presence: user.presence
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.isOverLimit
            ? _c(
                "Dropdown",
                {
                  key: "dropdown",
                  staticClass: "dropdown-wrapper",
                  attrs: {
                    placement: "bottom-end",
                    "position-fixed": _vm.dropdownPositionFixed,
                    "append-to-body": _vm.appendToBody
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function(ref) {
                          var toggle = ref.toggle;
                          var isOpen = ref.isOpen;
                          return _c(
                            "div",
                            {
                              staticClass: "trigger",
                              style: "border-color: " + _vm.borderColor,
                              attrs: { size: _vm.size, open: isOpen }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more", on: { click: toggle } },
                                [
                                  _c(
                                    "transition",
                                    {
                                      attrs: {
                                        name: _vm.counterUp
                                          ? "counter-up"
                                          : "counter-down"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          key: _vm.collapsedCount,
                                          staticClass: "collapsed-count"
                                        },
                                        [
                                          _vm._v(
                                            "+" + _vm._s(_vm.collapsedCount)
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3065111213
                  )
                },
                [
                  _vm._v(" "),
                  _vm._l(_vm.collapsed, function(collapsedUser) {
                    return _c(
                      "DropdownItem",
                      {
                        key: collapsedUser.key,
                        attrs: { "non-link": !collapsedUser.link }
                      },
                      [
                        collapsedUser.link
                          ? _c(
                              "a",
                              {
                                staticClass: "list-item",
                                attrs: {
                                  href: collapsedUser.link,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("Avatar", {
                                  staticClass: "user-list-avatar",
                                  attrs: {
                                    tag: "a",
                                    link: collapsedUser.link,
                                    size: "small",
                                    status: collapsedUser.status,
                                    outline: _vm.borderColor,
                                    avatar: collapsedUser.avatar,
                                    presence: collapsedUser.presence
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(collapsedUser.displayName))
                                ])
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "list-item" },
                              [
                                _c("Avatar", {
                                  staticClass: "user-list-avatar",
                                  attrs: {
                                    tag: "span",
                                    link: collapsedUser.link,
                                    size: "small",
                                    status: collapsedUser.status,
                                    outline: _vm.borderColor,
                                    avatar: collapsedUser.avatar,
                                    presence: collapsedUser.presence
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(collapsedUser.displayName))
                                ])
                              ],
                              1
                            )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-3d3e3c6b";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Avatar/AvatarGroup.vue.js